// apps/client/src/utils/subscription.ts

import { PlanOption, SubscriptionData } from '@fsp/types';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export class NoPaymentMethodError extends Error {
  code: string;

  constructor(message: string) {
    super(message);
    this.name = 'NoPaymentMethodError';
    this.code = 'no_payment_method';
  }
}

export const fetchPlans = async (): Promise<PlanOption[]> => {
  const response = await fetch(`${API_URL}/plans`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch plans');
  }

  const data = await response.json();
  return data.plans || [];
};

export const changePlan = async (
  priceId: string,
  currentSubscription?: SubscriptionData | null,
  promotionCode?: string
): Promise<void> => {
  const organisationId = localStorage.getItem('organisationId') || '';
  if (!organisationId) {
    throw new Error('No organisation selected');
  }

  const hasSubscription = currentSubscription?.subscription ? true : false;

  // let response = null;
  // if (hasSubscription) {
  //   response = await apiClient.put(`/organisations/${organisationId}/stripe/subscriptions`, {
  //     body: JSON.stringify({ priceId }),
  //   });
  // } else {
  //   response = await apiClient.post(`/organisations/${organisationId}/stripe/subscriptions`, {
  //     body: JSON.stringify({ priceId }),
  //   });
  // }

  const requestBody: any = { priceId };
  if (promotionCode) {
    requestBody.promotionCode = promotionCode;
  }

  const response = await fetch(`${API_URL}/organisations/${organisationId}/stripe/subscriptions`, {
    method: hasSubscription ? 'PUT' : 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    const errorData = await response.json();

    // Check for no payment method error
    if (errorData.code === 'no_payment_method') {
      throw new NoPaymentMethodError(
        errorData.message || 'Please add a payment method before creating a subscription'
      );
    }

    throw new Error(errorData.message || 'Failed to change subscription');
  }
};
